import './index.less'
import PanelArea from './PanelArea'
import ResultArea from './ResultArea'
import StickerArea from './StickerArea'

export default function SegmentPage() {
  return (
    <div className='segment-container'>
      <PanelArea />
      <StickerArea />
      <ResultArea />
    </div>
  )
}
